import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { httpClient, apiUrl } from './admin/dataProvider'

const Reset2FAPage: React.FC = () => {
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState<boolean | null>(null)
  const [message, setMessage] = useState('')
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setSuccess(false)
      setMessage('Missing token')
      setLoading(false)
      return
    }

    const doReset = async () => {
      try {
        setLoading(true)
        const { json } = await httpClient(
          `${apiUrl}/2fa/reset-by-token?token=${encodeURIComponent(token)}`,
          {
            method: 'GET',
          }
        )
        if (json && json.success) {
          setSuccess(true)
          setMessage('Your Two Factor Authentication has been reset.')
        } else {
          setSuccess(false)
          setMessage('Unable to reset 2FA. The link may be invalid or expired.')
        }
      } catch (e) {
        setSuccess(false)
        setMessage('Unable to reset 2FA. The link may be invalid or expired.')
      } finally {
        setLoading(false)
      }
    }

    doReset()
  }, [searchParams])

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        backgroundColor: '#f5f5f5',
        backgroundImage: 'url(/logo192.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center 40px',
        backgroundSize: '100px',
      }}
    >
      <Box mb={4} mt={-10}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Procurato - Spendtool
        </Typography>
      </Box>

      <Card sx={{ maxWidth: 600, width: '100%', p: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" component="h2" gutterBottom>
            2FA Reset
          </Typography>
          <Typography variant="body1" paragraph>
            {message}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => {
              window.location.replace('/admin/login')
            }}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  )
}

export default Reset2FAPage
